import './index.scss'
import Stepper from "../Stepper";
import React, {useEffect, useRef, useState} from "react";
import JsBridgeNew from "@/utils/jsbridgeNew";
import {hideLoading, showLoading} from "@/components/loading";
import Service from "@/view/supperzzle/service";
import appService from "@/utils/appService";
import {objectToQueryParams} from "@/utils/publicFun";
import {Toast} from "antd-mobile";
const ExchangeModal = ({ data, score, onClose, callBack, navigate, fromGems }) => {
  const stepperRef = useRef(null)
  const [count, setCount] = useState(1);
  const [success, setSuccess] = useState(false)
  const [needPoints, setNeedPoints] = useState(data.condition1)
  const [resultDate, setResultDate] = useState({})

  const handleOk = () => {
    onClose();
    callBack()
  }
  const handleChange = async () => {
    try {
      const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const params = {
        activityCode: fromGems ? Service.activityCode2 : Service.activityCode,
        userCode: userInfo?.loginName,
        count,
        points: needPoints,
        exgId: data.id,
      }
      showLoading()
      const res = await appService("600918",params, false)
      console.log('600918===>',res)
      if(res?.status === 1){
        setResultDate(res.data)
        setSuccess(true)
      } else {
        // Toast.show('兑换失败')
      }
      hideLoading()
    } catch (e) {
      console.log(e)
      hideLoading()
    }
  }
  const writeAddr = async () => {
    onClose()
    const param = objectToQueryParams({
      idf: 'commonSub',
      activityCode: fromGems ? Service.activityCode2 : Service.activityCode,
      req: resultDate.id,
      name: resultDate.prizeName,
      imgUrl: resultDate.prizeImgUrl,
      productId: resultDate.skuId,
      isChangeName:0,
      needShowCount: resultDate.count,
    });
    window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
    // onDidFocus();
  }
  const onCountChange = (ct)=> {
    if(ct) {
      setNeedPoints(Number(ct) * Number(data?.condition1))
      setCount(ct)
    }
  }
  return (
    <div className={'exchangeModal'}>
      <div className={'container'}>
        <div className={'title'}>{success ? '兑换成功' : '确认兑换'}</div>
        {success ? <div className="successContent">
          <img src={require('@/assets/img/supperzzle/successIcon.png')} alt=""/>
          </div>
        : <div className={'content1'}>
            <div>
              <img className="imgStyle" src={data.imgUrl} alt=""/>
            </div>
            <div className="stepperBox">
              <Stepper ref={stepperRef} maxValue={data.goodsNum}
                       defaultValue={1}
                       minValue={1}
                       onChange={onCountChange}
              />
            </div>
            <div className="textRow">点数<span className="pointsVale">{needPoints || 0}</span></div>
          </div>}
        <div className={'btnBox'}>
          {success ?
            data?.giftType !== 3 ? <button className="onlyOkBtn" onClick={handleOk}>确认</button>
              : <>
                <button className={'okBtn'} onClick={handleOk}>确认</button>
                <button className={'writeAddrBtn'} onClick={writeAddr}>填写地址</button>
              </>
            : <>
              <button className={'exchangeBtn'} onClick={handleChange}>兑换</button>
              <button className={'cancelBtn'} onClick={onClose}>取消</button>
            </>
          }
        </div>
      </div>
    </div>
  )
}
export default ExchangeModal